<template>
  <div class="rock-table-button">
    <vxe-button
      v-if="isMobile"
      :status="type"
      :icon="icon"
      :size="vxeSize"
      circle
      @click="handleClick"
    />
    <vxe-button
      v-else
      :status="type"
      :icon="icon"
      :size="vxeSize"
      :content="title"
      @click="handleClick"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RockTableButton",
  install(Vue) {
    Vue.component("RockTableButton", this);
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    pcIconVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      vxeSize: "vxeSize",
    }),
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
.rock-table-button {
  .vxe-button.size--medium {
    font-size: 12px;
  }
}

.rock-table-button + .rock-table-button {
  margin-left: 10px;
}
</style>
